'use client';

import { useCallback } from 'react';
import { wikiItemHref } from '../lib/wikiItemHref';
import { useCapability } from '../runtime/useCapability';
import { useLanguage } from '../stores/languageStore';

export function useWikiItemHref(): (wikiPath: string | null | undefined) => string | null {
  const enabled = useCapability('wikiLinks');
  const language = useLanguage();
  return useCallback((wikiPath) => (enabled ? wikiItemHref(language, wikiPath) : null), [enabled, language]);
}
